// extracted by mini-css-extract-plugin
export var content = "_cp-3";
export var list = "_cp-4";
export var settingsContent = "_cp-7";
export var settingsPanel = "_cp-8";
export var state = "_cp-6";
export var triggerBadge = "_cp-2";
export var triggerButton = "_cp-1";
export var triggerShell = "_cp-0";
export var unreadDot = "_cp-5";